module.exports = __webpack_public_path__ + "45293906341948d1a591eae6c393ab25.svg";